/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { HideSnackbar, ShowSnackbar, SNACKBAR_HIDE, SNACKBAR_SHOW } from './SnackbarNotificationActionTypes';
import { Dispatch } from 'react';
import { wrapIntoErrorObject } from '../../../errors/ErrorWrapper';

export interface SnackbarAction {
	type?: SnackbarType;
	message: string;
	url?: string;
}

export enum SnackbarType {
	SNACKBAR_SUCCESS = 'success',
	SNACKBAR_ERROR = 'error',
	SNACKBAR_INFO = 'info',
	SNACKBAR_WARNING = 'warning'
}

export const showSnackbar = (snackbar: SnackbarAction) => {
	return async (dispatch: Dispatch<ShowSnackbar>): Promise<void> => {
		dispatch({ type: SNACKBAR_SHOW, payload: snackbar });
	};
};

// return type hard to specify and anyway not needed
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const showSnackbarError = (error: unknown) => {
	return showSnackbar({
		type: SnackbarType.SNACKBAR_ERROR,
		message: wrapIntoErrorObject(error).displayMessage
	});
};

export const hideSnackbar = () => {
	return async (dispatch: Dispatch<HideSnackbar>): Promise<void> => {
		dispatch({ type: SNACKBAR_HIDE });
	};
};
